import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { ThemeProvider, Tooltip } from "@mui/material";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { format, startOfMonth } from "date-fns";

import GuidanceTableTheme from "../../../styles/tableTheme";
import IGuidance from "../../../types/IGuidance";
import PriceCell from "../../../components/PriceCell";
import { useIsMobile } from "../../../../../hooks/useIsMobile";

const currentMonth = startOfMonth(new Date());

const GuidanceTable = ({
  records,
  setRecords,
  editing,
  setEditing,
  selectMonth,
}: {
  records: IGuidance[];
  setRecords: (records: IGuidance[]) => void;
  editing: boolean;
  setEditing: (editing: boolean) => void;
  selectMonth: (date: string) => void;
}) => {
  const isMobile = useIsMobile(768);
  const onFocus = () => {
    setEditing(true);
  };

  const updateValue = (index: number, key: string, value: number) => {
    const newRecords = [...records];
    newRecords[index] = { ...newRecords[index], [key]: value };
    setRecords(newRecords);
  };

  return (
    <div>
      <ThemeProvider theme={GuidanceTableTheme}>
        {/* <TableContainer> */}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className="columnRow currentCell"
                style={{ width: 100, minWidth: 100, maxWidth: 100 }}
              />
              {records.map((r) => (
                <TableCell
                  key={r.date}
                  className="columnHeader currentCell"
                  style={{
                    margin: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    cursor:
                      !editing && (r.fobPrice > 0 || r.altPrice > 0)
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() => {
                    if (
                      !isMobile &&
                      !editing &&
                      (r.fobPrice > 0 || r.altPrice > 0)
                    ) {
                      selectMonth(r.date);
                    }
                  }}
                >
                  <Tooltip
                    title={
                      !editing && (r.fobPrice > 0 || r.altPrice > 0)
                        ? "View history"
                        : undefined
                    }
                  >
                    <div className="GuidanceTableHeader">
                      {format(new Date(`${r.date}T00:00`), "MMM yy")}
                      {!isMobile &&
                        !editing &&
                        (r.fobPrice > 0 || r.altPrice > 0) && (
                          <KeyboardArrowRightIcon />
                        )}
                    </div>
                  </Tooltip>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className="rowHeader currentCell">
                FOB Posted Px
              </TableCell>
              {records.map((r: any, index: number) => (
                <PriceCell
                  key={`Posted-${r.date}`}
                  value={r.fobPrice}
                  setValue={(value: number) => {
                    updateValue(index, "fobPrice", value);
                  }}
                  disabled={
                    new Date(`${r.date}T00:00`).valueOf() <
                    currentMonth.valueOf()
                  }
                  onFocus={onFocus}
                />
              ))}
            </TableRow>
            <TableRow>
              <TableCell className="rowHeader currentCell">
                Alternative
              </TableCell>
              {records.map((r: any, index: number) => (
                <PriceCell
                  key={`Alt-${r.date}`}
                  value={r.altPrice}
                  setValue={(value: number) => {
                    updateValue(index, "altPrice", value);
                  }}
                  disabled={
                    new Date(`${r.date}T00:00`).valueOf() <
                    currentMonth.valueOf()
                  }
                  onFocus={onFocus}
                />
              ))}
            </TableRow>
          </TableBody>
        </Table>

        {/* </TableContainer> */}
      </ThemeProvider>
    </div>
  );
};

export default GuidanceTable;
